module.exports = __webpack_public_path__ + "static/hifi8-51596754d7ff024591d943e757fe3cde.jpg";